import LazyLoad from "lazyload";
import TextScroller from "./includes/textscroller";
import NewsCarousel from "./includes/newscarousel";
import Timeline from "./includes/timeline";
import CardCarousel from "./includes/cardcarousel";
import Truths from "./includes/truths";
import ImageCarousel from "./includes/imagecarousel";
import SocialMediaCarousel from "./includes/socialmediacarousel";
import MobileNav from "./includes/mobilenav";
import VideoResource from "./includes/videoresource";
import thankyou from "./includes/thankyou";
import ScrollToTop from "./includes/scrolltotop";

thankyou.init();

let textScroller = new TextScroller(".scrollable_title");
textScroller.init();

let newsCarousel = new NewsCarousel();
newsCarousel.init();

let timeline = new Timeline();
timeline.init();

let cardcarousel = new CardCarousel();
cardcarousel.init();

let fourtruths = new Truths();
fourtruths.init();

let imagecarousel = new ImageCarousel();
imagecarousel.init();

let socialmediacarousel = new SocialMediaCarousel();
socialmediacarousel.init();

MobileNav();

let lazyLoadInstance = document.querySelectorAll(".lazy");
new LazyLoad(lazyLoadInstance);

let videoresource = new VideoResource();
videoresource.init();

let scrolltotop = new ScrollToTop();
scrolltotop.init();
